import { SECTIONS } from '@/constants/routes';
import ProductService from '@/services/productService';

class SvgProductRedirectService {
    registerRedirects(svgContainer, redirectId, activeSlide, router, store, isPreview) {
        const selectionBoxes = svgContainer.$el.querySelectorAll('polygon');
        selectionBoxes.forEach((s) => {
            const id = s.parentNode?.dataset?.name || s.parentNode?.id;
            s.onclick = (e) => this.handleProductClick(e, id, redirectId, activeSlide, isPreview, router, store);
        });
    }

    handleProductClick(e, s, redirectId, activeSlide, isPreview, router, store) {
        e.preventDefault();
        if (!isPreview) {
            if ('Ericsson_Silicon' === s) {
                router.push({
                    name: 'silicon',
                    query: { from: redirectId, activeSlide: activeSlide },
                }).catch(err => { });
                return;
            }
            const { product } = this.findProduct(s, store);
            router.push({
                name: product.prefix,
                params: {
                    product: product.name,
                    subproduct: product.optionalName ? `${product.optionalName}` : null,
                },
                query: { from: redirectId, activeSlide: activeSlide },
            });
        } else {
            const { selectedProduct } = this.findProduct(s, store);
            ProductService.setLocalProduct(selectedProduct);
            const link = router.resolve({ path: '/preview' });

            window.open(link.href);
        }
    }

    findProduct(id, store) {
      const product = { prefix: '', name: '', optionalName: '' };
      let selectedProduct = null;
      store.state.radios
        .filter((x) => !x.parentId)
        .forEach((radio) => {
          if (radio.productId.toUpperCase() === id.toUpperCase()) {
            product.prefix = SECTIONS.find(
              (s) => s.name === radio.sectionName
            ).prefix;
            product.name = radio.fileName;
            selectedProduct = radio;
          }

          const subproducts = store.state.radios.filter(
            (subradio) => subradio.parentId === radio.id
          );
          const subradio = subproducts.find(
            (subradio) => subradio.productId.toUpperCase() === id.toUpperCase()
          );
          if (subradio) {
            product.prefix = SECTIONS.find(
              (s) => s.name === radio.sectionName
            ).prefix;
            product.name = radio.fileName;
            product.optionalName = subradio.fileName;
            selectedProduct = subradio;
          }
        });
      return { product, selectedProduct };
    }
}

export default new SvgProductRedirectService();